import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';

@Component({
  selector: 'app-dialog-stop-scheduling-suggestions',
  templateUrl: './dialog-stop-scheduling-suggestions.component.html',
  styleUrls: ['./dialog-stop-scheduling-suggestions.component.scss']
})
export class DialogStopSchedulingSuggestionsComponent implements OnInit {

  @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  private maintenanceId: string;
  private form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<DialogStopSchedulingSuggestionsComponent>,
    private customMessageService: CustomMessagesService,
    private translateService: TranslateService,
    private maintenancesApi: MaintenancesApi,
  ) { }

  ngOnInit(): void {
    this.form = this.data;
    this.maintenanceId = this.form.get('id').value;
  }

  public closeDialog(): void {
    this.matDialogRef.close(true);
  }

  public async stopSchedulingSuggestions(): Promise<void> {
    this.isLoading.emit(true);
    this.matDialogRef.disableClose = true;

    try {
      await this.maintenancesApi.cancelMaintenanceScheduleSuggestions(this.maintenanceId).toPromise();
      const maintenance = await this.maintenancesApi.searchOne(this.maintenanceId).toPromise();
      this.form.get('status').setValue(maintenance.status);
      this.form.get('scheduleSuggestionsStatus').setValue(maintenance.scheduleSuggestionsStatus);
      this.customMessageService.success('MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.SUCCESS');
    } catch (err) {
      sentry.captureException(err);
      this.customMessageService.error('MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.ERROR');
    } finally {
      this.isLoading.emit(false);
      this.matDialogRef.disableClose = true;
      this.closeDialog();
    }
  }
}
